import Grid from '@mui/material/Grid';
import { useDevice } from 'components/DeviceContext.js';
import FacebookOutlinedIcon from '@mui/icons-material/FacebookOutlined';
import InstagramIcon from '@mui/icons-material/Instagram';
import XIcon from '@mui/icons-material/X';
import YouTubeIcon from '@mui/icons-material/YouTube';
import { Link as RouterLink } from 'react-router-dom';

function Sobre() {
  const { isMobile } = useDevice();

  const titleSx = {
    fontSize: isMobile ? '28px' : '44px',
    fontWeight: 800,
    margin: '0 0 14px 0',
    lineHeight: 1.05,
    letterSpacing: '-0.5px',
    color: 'var(--azul-card)',
  };

  const textSx = {
    fontSize: isMobile ? '14px' : '18px',
    lineHeight: 1.6,
    margin: 0,
    color: 'var(--azul-card)',
  };

  const linkSx = {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    textDecoration: 'none',
    color: 'var(--azul-card)',
    fontSize: isMobile ? '14px' : '18px',
    lineHeight: 1.5,
    padding: '4px 0',
    width: 'fit-content',
  };

  const sectionSx = {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
  };

  return (
    <Grid
      container
      justifyContent="center"
      style={{
        backgroundColor: '#f6f7f9',
        padding: isMobile ? '20px 14px' : '56px 18px',
      }}
    >
      <Grid
        item
        xs={12}
        style={{
          maxWidth: '1200px',
          width: '100%',
        }}
      >
        <Grid container spacing={isMobile ? 3 : 5} alignItems="flex-start">
          <Grid item xs={12} md={5}>
            <h2 style={titleSx}>Quem Somos</h2>
            <p style={textSx}>
              Criado pela Confederação Nacional de Municípios (CNM), o Observatório do Crack e Outras Drogas acompanha,
              desde 2011, as ações do poder público para a prevenção ao uso de drogas.
            </p>
          </Grid>

          <Grid item xs={12} sm={6} md={2.5}>
            <div style={sectionSx}>
              <h2 style={titleSx}>Sobre</h2>

              <RouterLink to="/noticias" style={linkSx}>Notícias</RouterLink>
              <RouterLink to="/legislacao" style={linkSx}>Legislação</RouterLink>
              <RouterLink to="/biblioteca" style={linkSx}>Biblioteca</RouterLink>
              <RouterLink to="/videos" style={linkSx}>Vídeos</RouterLink>

              {/* ✅ aqui é o que você precisava */}
              <RouterLink to="/boas-praticas" style={linkSx}>Boas Práticas</RouterLink>
            </div>
          </Grid>

          <Grid item xs={12} sm={6} md={2.5}>
            <div style={sectionSx}>
              <h2 style={titleSx}>Mapas</h2>
              <RouterLink to="/mapa-crack" style={linkSx}>Crack</RouterLink>
              <RouterLink to="/mapa-fronteiras" style={linkSx}>Fronteiras</RouterLink>
              <RouterLink to="/mapa-assistencia" style={linkSx}>Assistência</RouterLink>
            </div>
          </Grid>

          <Grid item xs={12} md={2}>
            <div style={sectionSx}>
              <h2 style={titleSx}>Siga</h2>

              <a
                href="https://www.facebook.com/portalcnm"
                target="_blank"
                rel="noreferrer"
                style={linkSx}
              >
                <FacebookOutlinedIcon fontSize="small" /> Facebook
              </a>

              <a
                href="https://x.com/i/flow/login?redirect_after_login=%2Fportalcnm"
                target="_blank"
                rel="noreferrer"
                style={linkSx}
              >
                <XIcon fontSize="small" /> Twitter
              </a>

              <a
                href="https://www.instagram.com/portalcnm/"
                target="_blank"
                rel="noreferrer"
                style={linkSx}
              >
                <InstagramIcon fontSize="small" /> Instagram
              </a>

              <a
                href="https://www.youtube.com/user/tvportalcnm"
                target="_blank"
                rel="noreferrer"
                style={linkSx}
              >
                <YouTubeIcon fontSize="small" /> YouTube
              </a>
            </div>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default Sobre;